export const normalizeResourceUrl = (value) => {
  const trimmed = String(value || "").trim();
  if (!trimmed) return "";

  try {
    const url = new URL(trimmed);
    if (url.protocol !== "https:" && url.protocol !== "http:") return "";
    return url.href;
  } catch {
    return "";
  }
};

export const mapLibraryRows = (rows) =>
  (rows || [])
    .map((row) => ({
      id: row?.id,
      name: row?.name,
      url: normalizeResourceUrl(row?.url),
      order_index: row?.order_index ?? null,
    }))
    .filter((row) => row.name && row.url);

export const normalizeResourceOrder = (resources) =>
  (resources || []).map((item, index) => ({ ...item, order_index: index }));

export const reorderList = (list, fromIndex, toIndex) => {
  const next = [...(list || [])];
  const [moved] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, moved);
  return next;
};
